import React, {useEffect} from 'react'
import AppContainer from "../../components/container/AppContainer";
import {MainTitleContainer, Margin25, Margin50} from "../../styles/GlobalStyles";
import Text from "../../components/text/Text";
import Colors from "../../styles/Colors";
import Section from "../../components/container/Section";
import AnimalCard from "../../components/card/AnimalCard";
import Racka from "../../assets/images/Racka.jpg";
import Heidschnucke from "../../assets/images/heidschnucke.jpg";
import Ouessant from "../../assets/images/ouessant.jpg";
import RouxDeValet from "../../assets/images/RouxDeValet.jpg";
import {GAPageView} from "../../services/AnalyticsService";

const Animals = () => {
    useEffect(() => {
        GAPageView("Animals")
    }, []);

    return (
        <AppContainer>
            <Margin50 />

            <MainTitleContainer>
                <Text
                    type={"h4"}
                    color={Colors.green}
                >
                    Des races variées, aux multiples qualités
                </Text>
            </MainTitleContainer>

            <Margin25 />

            <Section marginVertical={25}>
                <AnimalCard
                    title={"Roux du Valais"}
                    imageSrc={RouxDeValet}
                >
                    Discrète et efficace, le roux du Valais est une race de taille moyenne originaire du Valais Suisse.
                    Très efficace sur les zones à fortes pentes ainsi que les zones fortement enfrichées, elle se
                    contente d’une végétation pauvre.
                </AnimalCard>
            </Section>

            <Section marginVertical={25}>
                <AnimalCard
                    title={"Racka"}
                    imageSrc={Racka}
                    imageRight
                >
                    Originale et opportuniste, le Racka est une race originaire des pays de l’Est. De caractère plutôt
                    craintive, elle est parfaitement adaptée au grande plaine aride et pauvre, elle supporte aussi très
                    bien les prairies semi-humides.
                </AnimalCard>
            </Section>

            <Section marginVertical={25}>
                <AnimalCard
                    title={"Ouessant"}
                    imageSrc={Ouessant}
                >
                    Affectueuse et mignonne, l’Ouessant est la plus petite race de mouton français. Idéale pour les
                    petites surfaces, elle ne tasse pas le sol et ses déjections se décomposent rapidement au sol.
                </AnimalCard>
            </Section>

            <Section marginVertical={25}>
                <AnimalCard
                    title={"Heidschnucke"}
                    imageSrc={Heidschnucke}
                    imageRight
                >
                    Atypique et Agile, le Heidschnucke est parfaitement adapté à notre climat en résistant parfaitement
                    aux hivers rigoureux et aux étés chauds. Cette race se contente de végétations très pauvres y
                    compris sur des zones inaccessibles.
                </AnimalCard>
            </Section>
        </AppContainer>
    )
}

export default Animals
